@if (isValidValues()) {
<kendo-dropdownlist
  [data]="validValues"
  [textField]="textField"
  [valueField]="valueField"
  [valuePrimitive]="true"
  [value]="value"
  (selectionChange)="onChangedVal($event)"
></kendo-dropdownlist>
} @else if(isInt()) {
<kendo-numerictextbox
  [value]="value"
  [format]="'n0'"
  [decimals]="0"
  (valueChange)="onChange($event)"
></kendo-numerictextbox>
} @else if(isDouble()) {
<kendo-numerictextbox
  [value]="value"
  [format]="'n2'"
  [decimals]="3"
  (valueChange)="onChange($event)"
></kendo-numerictextbox>
} @else {
<kendo-textbox
  [value]="value"
  (valueChange)="onChange($event)"
></kendo-textbox>
}
